import React, { useContext, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteBoxApi, showDetailsBox } from "../services/leitnerApi";
import { checkErrorMessage, checkResponseData } from "../utils/utilsFunctions";
import mainContext from "../context/mainContext";
import { separationCards } from "../utils/studyCardUtils";
import EditBox from "./EditBox";

export default function BoxDetail() {
  const { handleCards, handleEditBoxlist, boxesList } = useContext(mainContext);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [deleteProcess, setDeleteProcess] = useState("noAction");
  const [deletedCards, setDeletedCards] = useState(0);
  const [editAction, setEditAction] = useState(false);
  const [boxInfo, setBoxInfo] = useState({});
  const [boxCards, setBoxCards] = useState([]);

  const handleBoxInfo = (data) => setBoxInfo(data);

  const getBoxInfo = async () => {
    try {
      let fetchedBoxInfo = {};
      let fetchedBoxCards = [];
      let remainCards = true;
      let page = 1;
      setLoading(true);
      while (remainCards) {
        const response = await showDetailsBox({ boxId: id }, { perPage: 50, page });
        const res = checkResponseData(response);
        if (res["success"]) {
          remainCards = res["data"]["hasNextPage"];
          page++;
          fetchedBoxCards.push(...res["data"]["docs"]);
          fetchedBoxInfo = response["data"]["boxInfo"];
        } else {
          fetchedBoxInfo = {};
          fetchedBoxCards = [];
          remainCards = false;
        }
      }
      handleBoxInfo(fetchedBoxInfo);
      setBoxCards(fetchedBoxCards);
      let cards = separationCards(fetchedBoxCards);
      handleCards(cards);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("BoxDetail error", error);
    }
  };

  const handleStartEditBox = (value) => {
    setDeleteProcess("noAction");
    setEditAction(value);
  };

  const handleDeleteBox = async () => {
    setDeleteProcess("inProcess");
    try {
      const deletedBox = await deleteBoxApi({ boxId: boxInfo["_id"] });
      const resData = checkResponseData(deletedBox);
      if (resData["success"]) {
        toast.success(resData["message"] || "حذف لایتنر با موفقیت انجام شد");
        const newBoxList = [...boxesList];
        let idx;
        for (let index in newBoxList) {
          if (newBoxList[index]["_id"] === boxInfo["_id"]) idx = index;
        }
        if (idx > 0) newBoxList.splice(idx, 1);
        handleEditBoxlist(newBoxList);
        setDeletedCards(resData["data"]["data"][0]["countCard"]["deletedCount"]);
        setDeleteProcess("doneDelete");
      } else {
        toast.error(resData["message"] || "مشکلی در حذف لایتنر وجود دارد");
        setDeleteProcess("question");
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.error(errMsg || "مشکلی در حذف لایتنر وجود دارد");
      setDeleteProcess("question");
    }
  };

  React.useEffect(() => {
    getBoxInfo();
  }, [id]);

  if (!boxInfo) return null;

  return (
    <div className="container" style={{ maxWidth: 720 }}>
      {editAction ? (
        <EditBox boxInfo={boxInfo} handleStartEditBox={handleStartEditBox} handleBoxInfo={handleBoxInfo} />
      ) : loading ? (
        <div className="center" style={{ marginTop: 48 }}>
          <div className="spinner"></div>
          <p style={{ color: "var(--text-secondary)", marginTop: 12 }}>در حال دریافت اطلاعات</p>
        </div>
      ) : deleteProcess === "doneDelete" ? (
        <div className="card" style={{ textAlign: "center" }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>🗑️</div>
          <p style={{ fontWeight: 600 }}>
            جعبه لایتنر به همراه{" "}
            <span style={{ color: "var(--danger)", fontWeight: 800 }}>{deletedCards}</span> کارت حذف شد
          </p>
          <Link
            className="btn"
            onClick={() => {
              setDeletedCards(0);
              setDeleteProcess("noAction");
              handleCards({ one: [], two: [], three: [], four: [], five: [], six: [], seven: [], eight: [], nine: [] });
            }}
            to="/home"
            style={{ textDecoration: "none", marginTop: 12, display: "inline-block" }}
          >
            بازگشت به خانه
          </Link>
        </div>
      ) : (
        <div className="card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 20 }}>{boxInfo.name}</h2>
              <span className="badge" style={{ marginTop: 6 }}>
                {boxInfo.fromLang} → {boxInfo.toLang}
              </span>
            </div>
            <div className="row" style={{ gap: 6 }}>
              <button className="btn ghost small" onClick={() => handleStartEditBox(true)}>
                ویرایش
              </button>
              <button
                disabled={deleteProcess === "inProcess"}
                className="btn danger small"
                onClick={() => setDeleteProcess(deleteProcess === "noAction" ? "question" : "noAction")}
              >
                حذف
              </button>
            </div>
          </div>
          <div className="row" style={{ marginTop: 12, gap: 12 }}>
            <span className="badge">لغات: <b>{boxCards.length}</b></span>
          </div>
          {boxInfo.description ? (
            <div style={{ marginTop: 8, color: "var(--text-secondary)", fontSize: 13 }}>
              {boxInfo.description}
            </div>
          ) : null}
          {deleteProcess === "noAction" ? (
            <Link className="btn" style={{ textDecoration: "none", marginTop: 16, display: "inline-block" }} to={`/review/${boxInfo._id}`}>
              شروع مرور
            </Link>
          ) : deleteProcess === "inProcess" ? (
            <div className="center" style={{ marginTop: 16, gap: 8, padding: 16, border: "1px solid var(--card-border)", borderRadius: "var(--radius-sm)" }}>
              <div className="spinner small"></div>
              <span>در حال حذف لایتنر ...</span>
            </div>
          ) : (
            <div style={{ marginTop: 16, padding: 16, border: "1px solid rgba(255,107,107,0.2)", borderRadius: "var(--radius-sm)", textAlign: "center" }}>
              <p style={{ margin: "0 0 12px", color: "var(--danger-light)", fontSize: 13 }}>
                با حذف این لایتنر تمامی لغات و سوابق مرور شما حذف خواهد شد.
              </p>
              <div className="row" style={{ justifyContent: "center" }}>
                <button className="btn ghost" style={{ flex: 1 }} onClick={() => setDeleteProcess("noAction")}>
                  انصراف
                </button>
                <button className="btn danger" style={{ flex: 1 }} onClick={handleDeleteBox}>
                  حذف لایتنر
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
